import React from 'react';

interface DetailsCardProps {
  id?: string;
  title?: string;
  buttons?: React.ReactNode;
  children?: React.ReactNode;
}

const DetailsCard: React.FC<DetailsCardProps> = ({ id, title, buttons, children }) => {
  return (
    <div id={id} className="rounded-2xl border border-border-primary bg-bg-card p-4 md:p-6 xl:p-7.5">
      <div className="flex justify-between items-center">
        {title && (
          <h2 className="text-xl font-semibold text-text-primary mb-4">{title}</h2>
        )}

        {buttons && (
          <div className="md:col-span-2 flex gap-3 mt-[-10px]">
            {buttons}
          </div>
        )}
      </div>


      {children}
    </div>
  );
};

export default DetailsCard;
